import React, { Component } from "react";
import styles from "./logisticAlatmTool.module.scss";
import AlarmDaysPanel from "./AlarmDaysPanel";
import { getDaysWeekState } from "./LogisticDaysWeekService";
import InputTime from "../../../shared/items/contols/inputTime";
import { withLogisticTripControlPoints } from "../../../shared/containers/containerLogisticTripControlPoints";
import getDates from "../../../shared/services/date.service";

class AlarmTimePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      valueStore: null,
      active: props.active,
    };
  }

  componentDidMount() {
    const { alarm } = this.props;

    const values = alarm.time === null ? "00:00" : alarm.time.split(":");
    const timeStart = this.getEmptyDateTime(values[0], values[1]);

    const timeEnd = this.addMinutes(timeStart, alarm.duration === null || alarm.duration === 0 ? 1 : alarm.duration);

    this.setState({
      valueStore: {
        timeStart,
        timeEnd,
      },
    });
  }

  getEmptyDateTime(hours = 0, minutes = 0) {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), parseInt(hours), parseInt(minutes), 0, 0);
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);

    return result;
  }

  addMinutes(date, minutes) {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() + minutes);

    return result;
  }

  onHandleChangeStore(e, value, name) {
    const { valueStore } = this.state;

    const { onSetTime } = this.props;
    valueStore[name] = e;

    this.setState({ valueStore });

    const time = getDates.getTimeFormat2(valueStore.timeStart);

    const duration =
      valueStore.timeEnd > valueStore.timeStart
        ? (valueStore.timeEnd - valueStore.timeStart) / 60000
        : (this.addDays(valueStore.timeEnd, 1) - valueStore.timeStart) / 60000;

    onSetTime(time, duration);
  }

  render() {
    const { valueStore } = this.state;
    if (valueStore === null) return null;
    const { disabled } = this.props;

    const titleTimeEnd = valueStore.timeEnd <= valueStore.timeStart ? "Время завершения на следующий день" : "Время завершения";

    return (
      <div className={styles.alarmForlarmTimePanelContainer}>
        <div className={styles.sheduleDateTimeInput}>
          <span>Время начала</span>
          <InputTime
            disabled={disabled}
            name={"timeStart"}
            onHandleChangeStore={(e, value) => {
              this.onHandleChangeStore(e, value, "timeStart");
            }}
            valueStore={valueStore}
          />
        </div>
        <div className={styles.sheduleDateTimeInput}>
          <span>{titleTimeEnd}</span>
          <InputTime
            disabled={disabled}
            name={"timeEnd"}
            onHandleChangeStore={(e, value) => {
              this.onHandleChangeStore(e, value, "timeEnd");
            }}
            valueStore={valueStore}
          />
        </div>
      </div>
    );
  }
}

export default withLogisticTripControlPoints(React.memo(AlarmTimePanel));
